import { createAPI } from '@common'
export default {
  // 删除
  postUsersDelete: config => createAPI('customEncryptApiName-1/0w20vtfst0efmfuf', 'post', config),
  // 主界面查询来源
  getRRTenants: config => createAPI('customEncryptApiName-1/0w20ss0ufobout', 'get', config),
  // 主界面查询角色
  getAdminRoles: config => createAPI('customEncryptApiName-1/0f60benjo0spmft', 'get', config),
  // 获取市列表
  getRRTenantsCities: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0djujft', 'get', config),
  // 读权限
  getAdminPermissionsGroups: config => createAPI('customEncryptApiName-1/0w20benjo0qfsnjttjpot0hspvqt', 'get', config),
  // 保存权限
  postAdminPermissionsGroups: config => createAPI('customEncryptApiName-1/0w20benjo0qfsnjttjpot0hspvqt', 'post', config),
  // 市列表
  getRrTenantsCities: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0djujft', 'GET', config),
  // 市下的租户列表
  getRrTenantsByCity: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0cz0djuz', 'GET', config),
  // 市列表（带权限判断）
  getRrTenantsCitiesByUser: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0djujft0cz0vtfs', 'GET', config),
  // 市列表（带权限判断）
  getRrTenantsGroupsByUser: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0hspvqt0cz0vtfs', 'GET', config),
  // 读一个租户的行政区划管理
  getRrTenant: config => createAPI('customEncryptApiName-1/0w20ss0ufobou', 'GET', config),
  // 第三方租户列表
  getRrTenantsOthers: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0puifst', 'GET', config),
  // 读租户站点列表
  getRrTenantsSites: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0tjuft', 'GET', config),
  // 读必推稿库的子层列表（带权限判断）
  getRrCatsByUser: config => createAPI('customEncryptApiName-1/0w20ss0dbut0cz0vtfs', 'GET', config),
  // 市+租户列表（不带权限）
  getRrTenantsList: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0mjtu', 'GET', config),
  // 市+租户列表（带权限）
  getRrTenantsListByUser: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0mjtu0cz0vtfs', 'GET', config)
}
